export enum Size {
  MedRectangle,
  MobileBanner
}

export interface AdProps {
  hide?: boolean;
  depth?: number;
  size: Size
}
